import { useCallback } from 'react';
import { useResourceCollection, useCreateResource, useUpdateResource, useDeleteResource, ResourceState, MutationState } from './useResource';
import { fleetVesselsService } from '../services';
import { FleetVessel } from '../types';
import { ResourceQueryOptions } from '../services/resources.service';

export function useFleetVessels(options?: ResourceQueryOptions): ResourceState<FleetVessel> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      fleetVesselsService.getAll(opts) as unknown as Promise<{ data: FleetVessel[]; meta?: any }>,
    []
  );
  return useResourceCollection<FleetVessel>(fetchFn, options);
}

export function useCreateFleetVessel(onSuccess?: () => void): MutationState<FleetVessel> {
  return useCreateResource<FleetVessel>(fleetVesselsService.create, onSuccess);
}

export function useUpdateFleetVessel(onSuccess?: () => void): MutationState<FleetVessel> {
  return useUpdateResource<FleetVessel>(fleetVesselsService.update, onSuccess);
}

export function useDeleteFleetVessel(onSuccess?: () => void): MutationState<void> {
  return useDeleteResource(fleetVesselsService.delete, onSuccess);
}
